import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import './Notifications.css';
import { connect } from 'react-redux';
import { NotificationsActions } from './Notifications.reducer';
import { ApiConstant, PageConstant, TitleConstant } from '../../../constants';
import moment from 'moment';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import history from '../../../services/history';
import { Pagination, Spin } from 'antd';
import { pushLog2DV2LogServer } from '../../../services/logging';

const NotificationType = {
  TAKE_SENIORITY_TEST: 'TAKE_SENIORITY_TEST',
  TAKE_1ST_MCQ: 'TAKE_1ST_MCQ',
  PASS_TECH_STACK: 'PASS_TECH_STACK',
  TAKE_ACC: 'TAKE_ACC'
};

const NotificationStatus = {
  PENDING: 'PENDING',
  READ: 'READ',
  DONE: 'DONE'
};

const Notifications = (props) => {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [items, setItems] = useState([]);
  const [total, setTotalCount] = useState(0);
  const [current, setCurrent] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (+props.notificationsCount > 0) {
      document.title = `(${props.notificationsCount}) ${TitleConstant}`;
    } else if (document.title !== TitleConstant) {
      document.title = TitleConstant;
    }
  }, [props.notificationsCount]);

  const initItem = (item) => {
    item.set = (data) => {
      setItems([...(items.map(elm => elm.id === item.id ? { ...item, ...data } : elm))]);
    };

    item.markAsRead = () => {
      const token = localStorage.getItem('token');
      const user = jwt.decode(token);
      pushLog2DV2LogServer.info(
        'DEVELOPER_NOTIFICATION',
        'NOTIFICATION_CLICK',
        {},
        {
          user_id: user.uid,
          user_email: user.email,
          notification_id: item.id,
          notification_type: item.type
        }
      );
      if (item.status === NotificationStatus.PENDING) {
        item.set({ loading: true });
        return new Promise(resolve => {
          axios.post(`${ApiConstant.BASE_URL}notifications/${item.id}/mark-as-read`)
            .catch(console.error)
            .finally(() => {
              loadData();
              item.set({ loading: false });
              resolve(true);
            });
        });
      } else {
        return Promise.resolve(true);
      }
    };

    item.click = () => {
      item.markAsRead().finally(() => {
        switch (item.type) {
          case NotificationType.TAKE_SENIORITY_TEST:
            history.push(PageConstant.TAKECHALLENGE_PAGE);
            break;
          case NotificationType.TAKE_1ST_MCQ:
          case NotificationType.PASS_TECH_STACK:
            history.push(PageConstant.GET_MULTI_CHOICES_CHALLENGE);
            break;
          case NotificationType.TAKE_ACC:
            history.push(PageConstant.CODING_CHALLENGE);
            break;
        }
        setNotificationStatus(false);
      });
    };
    return item;
  };

  items.map(initItem);
  const PAGE_SIZE = 3;
  const loadData = (page) => {
    if (!localStorage.getItem('token')) return;
    const start = ((page || 1) - 1) * PAGE_SIZE;
    setCurrent((page || 1));
    setLoading(true);
    axios.get(`${ApiConstant.BASE_URL}notifications?start=${start}&count=${PAGE_SIZE}`)
      .then(response => response.data)
      .then(({ code, data, totalCount, pendingCount }) => {
        if (code === 200) {
          if (Array.isArray(data)) {
            setItems(data.map(initItem));
          }
          setTotalCount(totalCount || 0);
          props.setNotificationsCount(pendingCount || 0);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (localStorage.getItem('token')) {
      loadData();
    }
  }, [localStorage.getItem('token') || '']);

  const setNotificationStatus = (open, mobile) => {
    if (mobile) {
      setPosition({ left: 20, top: 100 });
      document.body.classList.add('menu-notification-open');
    } else {
      const elem = document.querySelector('.menu-notification');
      if (open && elem) {
        setPosition({ left: elem.parentNode.offsetLeft + elem.parentNode.offsetWidth + 10, top: elem.offsetTop });
        document.body.classList.add('menu-notification-open');
      } else {
        document.body.classList.remove('menu-notification-open');
      }
    }
    setVisible(open);
  };

  useEffect(() => {
    const notificationMenuClick = () => {
      setNotificationStatus(!visible, false);
    };

    const notificationMobileMenuClick = () => {
      setNotificationStatus(!visible, true);
    };

    const anyClick = (e) => {
      if (e && e.target && e.target.closest) {
        if (!e.target.closest('.NotificationsComponent') && visible) {
          setNotificationStatus(false);
        }
      }
    };

    window.addEventListener('vetting-menu-notification-click', notificationMenuClick);
    window.addEventListener('vetting-mobile-menu-notification-click', notificationMobileMenuClick);
    window.addEventListener('click', anyClick);
    return () => {
      window.removeEventListener('vetting-menu-notification-click', notificationMenuClick);
      window.removeEventListener('vetting-mobile-menu-notification-click', notificationMobileMenuClick);
      window.removeEventListener('click', anyClick);
    };
  }, [visible, setVisible, props.notificationsCount]);

  return (
    <div className={`NotificationsComponent ${visible ? 'NotificationsComponent-visible' : ''}`} style={position}>
      <Spin spinning={loading}>
        <div className="NotificationsComponent-list">
          {!loading && !total && !items.length ? <div className="NotificationsComponent-empty">No notifications yet.</div> : null}
          {items.map(item => <NotificationsItem key={item.id} item={item} />)}
          {total > PAGE_SIZE ? <Pagination size="small" current={current} total={total} pageSize={PAGE_SIZE} onChange={loadData} /> : null}
        </div>
      </Spin>
    </div>
  );
};

Notifications.propTypes = {
  store: PropTypes.any,
  notificationsCount: PropTypes.number,
  setNotificationsCount: PropTypes.func,
  dispatch: PropTypes.func
};

const NotificationsItem = ({ item }) => {
  return (
    <div className='NotificationsItem' onClick={item.click}>
      <span className={`NotificationsItem-dot NotificationsItem-dot-${(item.status || '').toLowerCase()}`} />
      <Spin spinning={!!item.loading}>
        <p className='NotificationsItem-text'>{item.description}</p>
        <span className='NotificationsItem-time'>{moment(item.created_date).format('ddd DD MMM - LT')}</span>
      </Spin>
      <span className='material-icons'>arrow_forward_ios</span>
    </div>
  );
};

NotificationsItem.propTypes = {
  item: PropTypes.any
};

Notifications.onMenuClick = (e) => {
  e.preventDefault();
  window.dispatchEvent(new Event('vetting-menu-notification-click'));
};

Notifications.onMobileMenuClick = (e) => {
  e.preventDefault();
  window.dispatchEvent(new Event('vetting-mobile-menu-notification-click'));
};

const mapStateToProps = (store) => ({ store, notificationsCount: (store && store.notifications && store.notifications.notifications_count) ? store.notifications.notifications_count : 0 });
const mapDispatchToProps = (dispatch) => ({ dispatch, setNotificationsCount: n => dispatch({ type: NotificationsActions.SET_NOTIFICATIONS_COUNT, payload: n }) });

Notifications.Badge = connect(mapStateToProps, mapDispatchToProps)((props) => {
  if (props.notificationsCount) {
    return <span className='menu-badge'>{props.notificationsCount}</span>;
  }
  return null;
});

Notifications.Badge.propTypes = {
  store: PropTypes.any,
  notificationsCount: PropTypes.number,
  setNotificationsCount: PropTypes.func,
  dispatch: PropTypes.func
};

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);